import { useEffect, useState, useContext, useRef} from 'react'
import './css/main.css'
import { GET } from '../inc/Fetch';
import { useNavigate } from "react-router-dom";
import { AppContext } from '../Context';

export default function Logout({ data, article }) { 

    const { userData } = useContext(AppContext); 
    const [userinfo, setuserinfo] = userData;

    const navigate = useNavigate();


    async function logout() {

        let r = await GET("logout");
        setuserinfo({});

        navigate("/");
    }

    useEffect(() => {
        logout();
    }, [])
    

	return (
        <></>
    );
}
